import  api  from './api';

const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
}

export const getCorretoras = async () => {
    let corretoras = null;
    try {
        const response = await api.get(`Corretora/listcontroller`, config);
        corretoras = response.data.data;
    } catch (err) {}
    return corretoras;
}